export default __webpack_public_path__ + "static/falcevaya-krovlya-7c6c6f83cef4bd5164fce4c950e2c27f.jpg";